<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-input
          v-model="getReportTypeList_data.rtName"
          placeholder="请输入举报类型名"
          clearable
          size='small'
          style="max-width:380px;"/>
        <el-button
          v-click.getReportTypeList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
      <el-col :span="6" >
        <el-button
          v-if='addReportType'
          @click=" $form('addReportType') "
          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加举报类型
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getReportTypeList'
      api='getReportTypeList'
      updateapi='updateReportType'
      :height="H-165" >
    </mytable> 

    <myform
      :viewobj='{
        addReportType:    [ "新增举报类型信息", "el-icon-circle-plus" ],
        updateReportType: [ "修改举报类型信息", "el-icon-edit-outline"],
        $succeed$: getReportTypeList
      }'
      @close='$form("addReportType","reset")' >
      <!-- <hide slot='vtId' /> -->
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      vtId: null,

      tableColums_getReportTypeList: {
        $selection: false,

        rtName: '举报名称',

        $operation: [
          '操作', 200,
          this.updateReportType && `@text: 编辑#success
           @click: $form("updateReportType",$row)
          `,
          this.deleteReportType && `@text: 删除#danger
           @click: _confirm('确定要删除该举报类型吗?')
                   .trigger('deleteReportType',{vtId:$row.vtId})
                   .trigger('getReportTypeList')
          `,
        ],

      },

    };
  },

  watch: {
    
  },

  methods: {},

  created() {
    this.getReportTypeList();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/report/ReportType.vue